/** Сервис для работы с сводными данными */
import serviceApi from "./serviceApi";

export default class ServiceRagic {

    /**
     * Маршруты для запросов
     * @private
     * @static
     * @type {Object}
     * @property {String} summaryGroup - маршрут для получения легенды группы
     * @property {String} summarySelected - маршрут для получения легенды выбранного
     */
    static _requestRouts = {
        routeRagicFilterDates: 'order/dates',
        routeRagicFilterClients: 'order/clients',
        routeRagicFilterTableClients: 'order/table-clients',
        routeRagicFilterTableSuppliers: 'order/table-suppliers',
        routeRagicSendOrder: 'order/send',
        routeRagicRemoveOrder: 'order/remove'
    };

    /**
     * Получить сводные данные клиентов
     * @public
     * @static
     * @async
     * @param {Array} dates - Даты
     * @param {Array} clients - Клиенты
     * @param {Function} actionAfter - событие, сработающее после получения фильтра
     */
    static async postTableClients(dates = [], clients = [], actionAfter = () => {}) {
        try {
            let {data = {}} = await serviceApi.post(
                this._requestRouts.routeRagicFilterTableClients, {
                date: dates, inn: clients
            });
            actionAfter(this._postTableClientsAfter(data, true));
        } catch(error) {
            console.log(error);
        }
    }

    /**
     * Отправить в раджик
     * @public
     * @static
     * @async
     * @param {Number} clientId
     * @param {Function} actionAfter - событие, сработающее после получения фильтра
     */
    static async postSendOrder(clientId, actionAfter = () => {}) {
        try {
            await serviceApi.post(
                this._requestRouts.routeRagicSendOrder + "/" + clientId);
            actionAfter();
        } catch(error) {
            console.log(error);
        }
    }

    /**
     * Удалить заказ клиента
     * @public
     * @static
     * @async
     * @param {Number} clientId
     * @param {Function} actionAfter - событие, сработающее после получения фильтра
     */
    static async postRemoveOrder(clientId, actionAfter = () => {}) {
        try {
            await serviceApi.delete(
                this._requestRouts.routeRagicRemoveOrder + "/" + clientId);
            actionAfter();
        } catch(error) {
            console.log(error);
        }
    }

    /**
     * Получить сводные данные заказа клиента
     * @public
     * @static
     * @async
     * @param {Number} orderId
     * @param {Function} actionAfter - событие, сработающее после получения фильтра
     */
    static async postTableSuppliers(orderId, actionAfter = () => {}) {
        try {
            let {data = {}} = await serviceApi.post(
                this._requestRouts.routeRagicFilterTableSuppliers, {
                    order_client_id: orderId
                });
            actionAfter(this._postTableClientsAfter(data, false));
        } catch(error) {
            console.log(error);
        }
    }

    /**
     * Фильтр дат
     * @public
     * @static
     * @async
     * @param {Array} dates - Даты
     * @param {Array} clients - Клиенты
     * @param {Function} actionAfter - событие, сработающее после получения фильтра
     */
    static async postFilterDates(dates = [], clients = [], actionAfter = () => {}) {
        try {
            let {data = {}} = await serviceApi.post(
                this._requestRouts.routeRagicFilterDates);
            actionAfter(this._postFilterDatesAfter(data));
        } catch(error) {
            console.log(error);
        }
    }

    /**
     * Фильтр клиентов
     * @public
     * @static
     * @async
     * @param {Array} dates - Даты
     * @param {Array} clients - Клиенты
     * @param {Function} actionAfter - событие, сработающее после получения фильтра
     */
    static async postFilterClients(dates = [], clients = [], actionAfter = () => {}) {
        try {
            let {data = {}} = await serviceApi.post(
                this._requestRouts.routeRagicFilterClients, {
                    date: dates
                });
            actionAfter(data);
        } catch(error) {
            console.log(error);
        }
    }

    /**
     * Адаптер для фронта
     * @param {Array} items - массив дат
     * @return Object
     * @private
     */
    static _postFilterDatesAfter(items) {
        let map = {};
        items.forEach((item) => {
            map[item] = item;
        })
        return map;
    }

    /**
     * Адаптер для фронта
     * @param {Object} data - данные таблицы
     * @param {Object} data.fields - названия столбцов
     * @param {Array} data.items - строки
     * @param {Boolean} withDetail
     * @return Object
     * @private
     */
    static _postTableClientsAfter(data, withDetail) {
        const {fields = {}, items = []} = data;
        let columnSettings = {};
        Object.keys(fields).forEach((field) => {
            columnSettings[field] = {type: field === 'order_id' && withDetail ? "emit" : "text"};
        });
        items.forEach((item) => {
            if(withDetail){
                item.additionalButtons = ["send", "remove"];
            }

        });
        return {fields, columnSettings, items};
    }
}
